import React from 'react';

export const CorporateBannerComponent = (props) => {
    const { backgroundColor, businessName, businessNameColor, logo, links, linkColor, email } = props.content;

    const background = { /* stylelint-disable */
        backgroundColor: backgroundColor
    }
    const color = {
        color: linkColor
    }
    const nameColor = {
        color: businessNameColor
    }
    /* stylelint-enable */
    return (
        <section className="kiwi-banner__corporate" >
            <div className="mask" style={background}>
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="banner__logo">
                                <img src={logo} alt="" />
                            </div>
                            <h1 className="h1 heading-main banner__company-name" style={nameColor}>
                                {businessName}
                            </h1>
                        </div>
                    </div>
                    {(links || email) &&
                        <div className="row">
                            <div className="col-xs-12">
                                <ul className="company-links">

                                    {email &&
                                        <li className="company-links__item">
                                            <a href={`mailto:${email}`}><i className="fa fa-envelope" style={color} /></a>
                                        </li>
                                    }

                                    {links &&
                                        links.map((link, i) => {
                                            return <li className="company-links__item" key={i}>
                                                <a href={link.linkUrl} target="_blank">
                                                    <i className={`fa fa-${link.linkType}`} style={color} />
                                                </a>
                                            </li>
                                        })
                                    }

                                </ul>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </section>
    )
};


// WEBPACK FOOTER //
// src/client/components/common/CMS/components/CorporateBannerComponent.js